import { AVATAR_VARIANT, AvatarVariant } from '../../atoms/Avatar/Avatar.types';

export const getInitials = (name: string, maxInitials: number = 2): string => {
  return name
    .split(/\s/)
    .map((part) => part.substring(0, 1).toUpperCase())
    .filter((v) => !!v)
    .slice(0, maxInitials)
    .join('')
    .toUpperCase();
};

// https://en.wikipedia.org/wiki/Linear_congruential_generator
function stringAsciiPRNG(value: string, m: number) {
  const charCodes = [...value].map((letter) => letter.charCodeAt(0));
  const len = charCodes.length;

  const a = (len % (m - 1)) + 1;
  const c = charCodes.reduce((current, next) => current + next) % m;

  let random = charCodes[0] % m;

  for (let i = 0; i < len; i++) {
    random = (a * random + c) % m;
  }

  return random;
}

export function getAvatarVariant(
  value?: string,
  colors: AvatarVariant[] = Object.values(AVATAR_VARIANT).filter(
    (v) => v !== AVATAR_VARIANT.DEFAULT,
  ),
): AvatarVariant {
  if (!value) {
    return AVATAR_VARIANT.DEFAULT;
  }
  const colorIndex = stringAsciiPRNG(value, colors.length);

  return colors[colorIndex];
}
